var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconViewFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 32,
    viewBox: "0 0 31 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.0140381,
    y: 0.50708,
    width: 30.9859,
    height: 30.9859,
    rx: 15.493,
    fill: "#D4DBE9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_404_1941)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.507 21.4666C10.2781 21.4666 7.69008 16.4754 7.58444 16.2642C7.50522 16.1057 7.50522 15.8944 7.58444 15.736C7.69008 15.5247 10.2781 10.5599 15.507 10.5599C20.7359 10.5599 23.3239 15.5247 23.4295 15.736C23.5087 15.8944 23.5087 16.1057 23.4295 16.2642C23.3239 16.4754 20.7359 21.4666 15.507 21.4666ZM8.79923 16.0001C9.38022 16.9772 11.6513 20.2782 15.507 20.2782C19.3626 20.2782 21.6337 16.9772 22.2147 16.0001C21.6337 15.023 19.3626 11.7219 15.507 11.7219C11.6513 11.7219 9.38022 15.023 8.79923 16.0001Z",
    fill: "#284993"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.507 18.2447C14.2658 18.2447 13.2623 17.2412 13.2623 16C13.2623 14.7588 14.2658 13.7552 15.507 13.7552C16.7482 13.7552 17.7517 14.7588 17.7517 16C17.7517 17.2412 16.7482 18.2447 15.507 18.2447ZM15.507 14.9436C14.926 14.9436 14.4506 15.419 14.4506 16C14.4506 16.581 14.926 17.0563 15.507 17.0563C16.088 17.0563 16.5633 16.581 16.5633 16C16.5633 15.419 16.088 14.9436 15.507 14.9436Z",
    fill: "#284993"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_404_1941"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.9014,
    height: 16.9014,
    fill: "white",
    transform: "translate(7.05627 7.54932)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconViewFile);
export default __webpack_public_path__ + "static/media/icon-viewFile.8965b2f3383c4753266a7b2931a2c57e.svg";
export { ForwardRef as ReactComponent };